/**
 * Extract a user-facing message from a thrown focused-view data error.
 *
 * The data hooks `throw asApiError(result)` on failure, which yields an
 * `IOperationResultNoValue` shaped like `{ systemMessage }` — NOT an `Error`,
 * so `err.message` is `undefined`. Reading `.message` swallowed the real
 * backend reason and reps only saw the generic fallback. Prefer
 * `systemMessage`, then a standard `Error.message`, then the fallback.
 */
export const apiErrorMessage = (err: unknown, fallback: string): string => {
	if (err && typeof err === 'object') {
		const systemMessage = (err as { systemMessage?: unknown }).systemMessage;
		if (typeof systemMessage === 'string' && systemMessage.trim().length > 0) {
			return systemMessage;
		}
		const message = (err as { message?: unknown }).message;
		if (typeof message === 'string' && message.trim().length > 0) {
			return message;
		}
	}
	return fallback;
};
